import { Modal, ModalBody, ModalTitle, Button } from '@serodigital/ui-components';
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from 'luxon';
import * as React from 'react';

interface IDataPacketModalProps {
  isOpen: boolean;
  title: string;
  handleCloseModal: () => void;
  peripheralData?: JSON;
}

export const DataPacketModal = ({ isOpen = false, title, handleCloseModal, peripheralData }: IDataPacketModalProps) => {
  const getLineNumbers = (code: string) => {
    const lines = code.split('\n');
    return lines.map((_, index) => (
      <div key={uuidv4()} className='text-right pr-4 opacity-70'>
        {index + 1}
      </div>
    ));
  };

  const doesPeripheralDataExist = (data: JSON) => {
    if (!data) {
      return 'Failed to fetch data.';
    }
    const formattedCode: string = JSON.stringify(data, null, 2);
    return (
      <pre>
        <div className='flex flex-row bg-gray-900 rounded-md p-2'>
          <div className='flex flex-col bg-[#D9D9D9] py-[5px] pl-[5px] pr-[1px]'>{getLineNumbers(formattedCode)}</div>
          <div className='flex flex-col flex-grow p-[5px]'>{formattedCode}</div>
        </div>
      </pre>
    );
  };

  const timestamp = (peripheralData as unknown as any)?.timestamp;

  const dataLastUpdated = DateTime.fromISO(timestamp, { zone: 'utc' });

  return (
    <Modal data-qa={`peripheral-${title}`} isOpen={isOpen}>
      <ModalTitle headerClassName='!ml-0 !mb-8'>{title}</ModalTitle>
      <ModalBody>
        <div className='pb-[0.6rem] sero-font-small sero-text-h6'>
          Here you can see packet data returned by the peripheral.
        </div>
        <p className='pb-[0.5rem]'>{`Last Updated: ${dataLastUpdated?.toFormat(
          'EEE d MMMM',
        )} at ${dataLastUpdated?.toFormat('T')}`}</p>
        <div
          data-qa='peripheral-data-container'
          className='max-w-[60rem] min-w-[50rem] max-h-[30rem] min-h-[25rem] overflow-y-auto bg-[#FBFAFA]'
        >
          {doesPeripheralDataExist(peripheralData)}
        </div>
      </ModalBody>
      <div className='!mb-16 !mr-16 self-end'>
        <Button onClick={handleCloseModal} className='ml-8' kind='primary' data-qa='peripheral-close'>
          Close
        </Button>
      </div>
    </Modal>
  );
};
